import * as React from 'react';
import {BaseTabella} from './BaseTabella';
import {TabellaLista} from './TabellaLista';
import {ChiamaAPI, Trad} from './';
import {Link, NavLink} from 'react-router-dom';
import * as Dati from '../Dati';

export class BinderLista extends BaseTabella {

    public constructor(props: any) {
        super(props);
        this.state = {}
        this.PopolaRighe = this.PopolaRighe.bind(this);
        this.GetSfondoRiga = this.GetSfondoRiga.bind(this);
    }

    protected PopolaColonne: () => React.ReactNode = function () {
        return <tr className="kt-datatable__row" style={{height: 53}} key={0}>
            <th data-field="ID_Binder"
                className="kt-datatable__cell--center kt-datatable__cell kt-datatable__cell--sort">
                <span style={{width: 150}}>#</span>
            </th>
            <th data-field="CodiceBinder"
                className="kt-datatable__cell--center kt-datatable__cell kt-datatable__cell--sort"><span
                style={{width: 120}}>{Trad.Trad("CodiceBinder")}</span>
            </th>
            <th data-field="AnagraficaDa"
                className="kt-datatable__cell kt-datatable__cell--sort"><span
                style={{width: 132}}>{Trad.Trad("Da")}</span>
            </th>
            <th data-field="AnagraficaA"
                className="kt-datatable__cell kt-datatable__cell--sort"><span
                style={{width: 132}}>{Trad.Trad("A")}</span>
            </th>
            <th data-field="DataEffetto"
                className="kt-datatable__cell kt-datatable__cell--sort"><span
                style={{width: 132}}>{Trad.Trad("Data effetto")}</span>
            </th>
            <th data-field="DataFine" className="kt-datatable__cell kt-datatable__cell--sort"><span
                style={{width: 132}}>{Trad.Trad("Data fine")}</span>
            </th>
            <th data-field="DataStipula"
                className="kt-datatable__cell kt-datatable__cell--sort"><span
                style={{width: 132}}>{Trad.Trad("Data emissione")}</span>
            </th>
            <th data-field="ShipAddress"
                className="kt-datatable__cell kt-datatable__cell--sort"><span
                style={{width: 100}}>{Trad.Trad("Azioni")}</span>
            </th>
        </tr>;
    };

    protected PopolaRighe: (RDati?: Dati.CDatiBinder[], Funzione1?: (i: number) => string) => React.ReactNode = function (RDati, GetSfondoRiga) {
        //{ this.GetSfondoRiga(i) }
        if (RDati == undefined || GetSfondoRiga == undefined)
            return false;

        var R = [];
        for (var i = 0; i < RDati.length; i++) {
            R.push(
                <tr data-row={i} className={GetSfondoRiga(i)} style={{height: 50}} key={i + 1}>
                    <td data-field="ID" className="kt-datatable__cell--center kt-datatable__cell">
                        <span style={{width: 150}}>
                            <NavLink to={"/binder/" + RDati[i].ID_Binder}
                                     className="btn btn-brand kt-btn btn-sm 	kt-btn kt-btn--icon"
                                     title="View">
                                <span> <i className="la la-edit"></i>
                                    {RDati[i].ID_Binder}
                                </span>
                            </NavLink>
                        </span>
                    </td>
                    <td data-field="CodiceBinder" className="kt-datatable__cell"><span
                        style={{width: 120}}>{RDati[i].CodiceBinder}</span>
                    </td>
                    <td data-field="AnagraficaDa"
                        className="kt-datatable__cell--sorted kt-datatable__cell"><span
                        style={{width: 132}}>{RDati[i].AnagDa}</span>
                    </td>
                    <td data-field="AnagraficaA"
                        className="kt-datatable__cell--sorted kt-datatable__cell"><span
                        style={{width: 132}}>{RDati[i].AnagA}</span>
                    </td>
                    <td data-field="DataEffetto"
                        className="kt-datatable__cell--sorted kt-datatable__cell"><span
                        style={{width: 132}}>{RDati[i].DataEffetto || ""}</span>
                    </td>
                    <td data-field="DataFine"
                        className="kt-datatable__cell--sorted kt-datatable__cell"><span
                        style={{width: 132}}>{RDati[i].DataFine || ""}</span>
                    </td>
                    <td data-field="DataStipula"
                        className="kt-datatable__cell--sorted kt-datatable__cell"><span
                        style={{width: 132}}>{RDati[i].DataStipula || ""}</span>
                    </td>
                    <td data-field="Actions" className="kt-datatable__cell"><span
                        style={{width: 100}}>
                        <NavLink to={"/binder/" + RDati[i].ID_Binder}
                                 className="kt-portlet__nav-link btn kt-btn
                                 kt-btn--hover-accent kt-btn--icon btn--icon-only kt-btn--pill"
                                 title="View">
                            <i className="la la-edit"></i>
                        </NavLink>
                    </span>
                    </td>
                </tr>
            )
        }
        return R;
    };

    public render() {
        return <TabellaLista CSS={this.props.CSS} Id={this.props.Id} Name={this.props.Name}
                             OnChange={this.props.OnChange} PopolaColonne={this.PopolaColonne}
                             PopolaRighe={this.PopolaRighe} Dati={this.props.Dati}
                             Funzione1={this.GetSfondoRiga}/>;
    }
}



// WEBPACK FOOTER //
// ./src/components/BinderLista.tsx